import {
    useEffect,
    useState
} from "react";

import PdfView
    from "../../component/pdfView";

import DocxLabView
    from "../../component/docxLabView";

import InternalPdfView
    from "../../component/internalPdfView";

import {
    useParams
} from "react-router-dom";

import {
    getBySlug,
    getReaderMeta
} from "../../api/myBook";

import {
    Empty,
    message,
    Spin
} from "antd";

import {
    useDevice
} from "../../hooks";



import {
    isIOSDevice,
    isMobileBooksOSDevice,
    getBooksOSStoreUrl
} from "../../utils/booksOs";

export default function BookDetail() {

    const requiresApp = isMobileBooksOSDevice();
    const isIOS = isIOSDevice();

    const param =
        useParams();

    const {
        isMobile
    } = useDevice();

    const [book, setBook] =
        useState([]);

    const [readerType, setReaderType] =
        useState(null);

    const [detecting, setDetecting] =
        useState(true);

    const user =
        JSON.parse(
            localStorage.getItem(
                "user"
            )
        );


    useEffect(() => {

        const query =
            `user_id=${user?.user_id}`;

        getBySlug(
            param?.slug,
            query,
            setBook,
            message
        );

    }, []);


    useEffect(() => {

        if (
            !param?.slug ||
            !user?.user_id
        ) {
            setDetecting(false);
            return;
        }

        let active =
            true;

        setDetecting(true);

        getReaderMeta(
            param.slug,
            user.user_id
        )
            .then(
                response => {

                    if (!active) {
                        return;
                    }

                    setReaderType(
                        response?.data?.kind ||
                        "pdf"
                    );
                }
            )
            .catch(
                error => {

                    console.log(
                        "reader meta error:",
                        error
                    );

                    /*
                     * Neu metadata loi,
                     * giu co che PDF cu de khong lam mat sach.
                     */
                    if (active) {
                        setReaderType(
                            "pdf"
                        );
                    }
                }
            )
            .finally(
                () => {

                    if (active) {
                        setDetecting(
                            false
                        );
                    }
                }
            );

        return () => {
            active = false;
        };

    }, [
        param?.slug,
        user?.user_id
    ]);



    if (requiresApp) {
        return (
            <div className="min-h-[75vh] flex items-center justify-center bg-[#f5f7fa] px-4 py-8">
                <div className="w-full max-w-[460px] rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-lg">
                    <div className="mb-4 text-5xl">📚</div>
                    <h2 className="mb-3 text-xl font-bold text-gray-900">
                        Đọc sách bằng ứng dụng OS BOOKS
                    </h2>
                    <p className="mb-5 text-sm leading-6 text-gray-600">
                        Để đọc sách trên điện thoại hoặc máy tính bảng,
                        vui lòng mở ứng dụng {isIOS ? "OS BOOKS" : "Books OS"}.
                        Website chỉ hỗ trợ đọc trực tiếp trên máy tính.
                    </p>
                    <a
                        href={getBooksOSStoreUrl()}
                        className="flex min-h-[48px] items-center justify-center rounded-xl bg-blue-600 px-4 font-semibold text-white no-underline hover:bg-blue-700 hover:text-white"
                    >
                        {isIOS ? "MỞ / TẢI TRÊN APP STORE" : "MỞ / TẢI TRÊN GOOGLE PLAY"}
                    </a>
                </div>
            </div>
        );
    }

    if (
        book?.data?.length <= 0
    ) {
        return (
            <Empty />
        );
    }


    if (detecting) {
        return (
            <div
                className="
                    min-h-[60vh]
                    flex
                    items-center
                    justify-center
                "
            >
                <Spin size="large" />
            </div>
        );
    }


    const title =
        book?.data?.[0]?.product_name ||
        "Tài liệu";


    if (
        readerType ===
        "docx"
    ) {
        return (
            <DocxLabView
                slug={
                    param?.slug
                }
                title={
                    title
                }
            />
        );
    }


    /*
     * PDF VA CAC FILE CU:
     * GIU NGUYEN CO CHE DOC HIEN TAI.
     */
    return (
        <section
            className={`
                max-w-screen-2xl
                mx-auto
                ${isMobile
                    ? ""
                    : "my-5"
                }
            `}
        >
            <InternalPdfView
                slug={
                    param?.slug
                }
                title={
                    title
                }
            />
        </section>
    );
}
